import React from 'react';



const Events = (props)=>{

    const eventsData = props.eventsData.data;

    return(

        <>
            {
                eventsData.map((events, index)=>{
    
                    return(
                             <div key={index} className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-wrap">
                                <div className="block shadow">
                                    <div className="img-block">
                                        <img src={events.img} alt="" />
                                    </div>
                                    <div className="content">
                                        <div className="row m-0">
                                            <div className="col-12 p-0">
                                                <p className="blockHeading">
                                                    {events.title}
                                                </p>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-6 p-0 ">
                                                    <p className="blockText1">
                                                    {events.date}
                                                    </p> 
                                                </div>
                                                <div className="col-6 p-0 blockText2">
                                                    <a href={events.link}>More +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                    );
    
                })
            }
      </>  
    );

}

export default React.memo(Events);